// extracted by mini-css-extract-plugin
module.exports = {"componentIconTitle":"ComponentTitle_componentIconTitle__veqc3"};